import React, { useMemo } from "react";

import { AddTo } from "../../../../components/svg/svgImageList";
import { AddJobToProject as PermissionAddToProject } from "../../../../services/authorization/Permissions";
import Button from "../../../../components/button/Button";
import useThemeService from "../../../../services/theme-service/ThemeService";
import useModal from "../../../../components/dialog/useModal";
import { permissionsService } from "../../../../services/authorization/UserPermissionsService";
import { MultipleJobsActionProps } from "./MultipleJobsActionProps";
import { AddJobToProjectButtonModal } from "../Dialogs";

export function AddJobToProjectButton(props: MultipleJobsActionProps) {
  const { themeClass } = useThemeService();

  const { isVisible, toggleModal } = useModal();

  const { jobsStorage } = { ...props };

  const disabled = useMemo(
    () =>
      !permissionsService.userHasPermissionTo(PermissionAddToProject) ||
      !jobsStorage.anyItemsSelected,
    [jobsStorage.anyItemsSelected]
  );

  return (
    <>
      <Button
        id="add-job-to-project-button"
        icon={{
          svg: AddTo,
          textKey: "jobs.AddJobToProjectButton.label",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-add-to-project"]),
        }}
        disabled={disabled}
        onClick={toggleModal}
      />
      <AddJobToProjectButtonModal
        isVisible={isVisible}
        toggleModal={toggleModal}
        jobsStorage={jobsStorage}
      />
    </>
  );
}
